module.exports = __webpack_public_path__ + "img/app_store.3a1afedc.png";